/**
 * @module api/public
 *
 * API for public requests
 *
 * @version 1.0.0
 * @copyright Kind Challenge 2021
 */

import axios from 'axios';

const KIND_API_PUBLIC_URL = 'https://wpcdc75hw3.execute-api.eu-west-1.amazonaws.com/dev/';

// const SET_HEADERS = token => ({
//   'Content-Type': 'application/json',
//   'Access-Control-Allow-Origin': '*',
//   Authorization: `Bearer ${token}`,
// });

/**
 * Get list of cities
 *
 * @since Version 1.0.0
 */

/* eslint-disable */
export const apiGetCities = async () => {
  const config = {
    headers: {
      'Content-Type': 'application/json',
      'Access-Control-Allow-Origin': '*',
    },
  };

  const { data } = await axios.get(`${KIND_API_PUBLIC_URL}public/cities`, config);
  return data;
};
